module.exports = __webpack_public_path__ + "static/img/20-1.68d364de.jpg";